const resources = {
    thanksMessage: 'Merci pour vos commentaires!',
    submit: 'Soumettre',
    close: 'proche',
    errorMessage: 'Un problème est survenu. Veuillez essayer de nouveau.'
};

export default function getResource(label) {
    return resources[label];
}
